import PodcastPageConfig from "pages/podcast/config";
import { usePodcastProvider, ModalType } from "components/podcast/PodcastProvider";
//ui
import { Button, Flex, IconButton, Text } from "@chakra-ui/react";
import { StarIcon } from "components/icons";

interface ModalButtonsInterface {
  onOpen: () => void;
}
export function SubscribeButton({ onOpen }: ModalButtonsInterface) {
  const { setModalType } = usePodcastProvider();

  const handleClick = () => {
    setModalType(ModalType.Subscribe);
    onOpen();
  };
  return (
    <Flex display={PodcastPageConfig?.subscription ? "flex" : "none"}>
      <Button
        onClick={handleClick}
        borderRadius="6px"
        alignItems="center"
        spacing="50px"
        bg="gray.150"
        maxWidth="175px"
        py="12px"
        height="48px"
        px="24px"
        color="#4D3D8D"
        fontSize="16px"
        lineHeight="24px"
        fontWeight="600"
        font="sora"
        _hover={{
          bg: "gray.150"
        }}
        display={{ base: "none", sm: "flex" }}
      >
        <StarIcon height="24px" width="24px" />
        <Text fontWeight="bold" ml={1} letterSpacing="wider" font="sora" pl="12px">
          Subscribe
        </Text>
      </Button>
      <IconButton
        icon={<StarIcon width="48px" height="48px" color="white" />}
        bg="transparent"
        _hover={{ bg: "transparent" }}
        aria-label="subscribe-to-podcast"
        display={{ sm: "none" }}
        width="48px"
        height="48px"
        onClick={handleClick}
      />
    </Flex>
  );
}
